// Mahan Dryer
import React from "react";
import { CommonRows, InputRangeRow, RadioButtonRow, RadioLabelCol, RunTimeRow } from "./index";

export default function MachineMahanDryer() {
   return (
      <>
         <InputRangeRow
            titleProp={"High Limit"}
            descriptionProp={"\u00b0F"}
            sizeProp={3}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={999}
            propertyNameProp={"highLimit"}
            errorDialogueProp={"1-999"}
            floatProp={false}
         />

         <InputRangeRow
            titleProp={"Temperature Controller"}
            descriptionProp={"\u00b0F"}
            sizeProp={3}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={999}
            propertyNameProp={"tempControl"}
            errorDialogueProp={"1-999"}
            floatProp={false}
         />

         <RunTimeRow TitleProp="Timer Set" ColPromptSizeProp={3} ColValueSizeProp={3} />

         <RadioButtonRow promptRowSizeProp={3} valueRowSizeProp={4} titleProp={"Circulation Fan"} descriptionProp="">
            <RadioLabelCol groupNameProp={"fanGroup"} valueProp={1} onChangeProp={"fan"} displayProp={"Start"} stringProp />
            <RadioLabelCol groupNameProp={"fanGroup"} valueProp={0} onChangeProp={"fan"} displayProp={"Stop"} stringProp />
         </RadioButtonRow>

         <RadioButtonRow promptRowSizeProp={3} valueRowSizeProp={4} titleProp={"Exhaust & Combustion"} descriptionProp="">
            <RadioLabelCol groupNameProp={"exhaustGroup"} valueProp={1} onChangeProp={"exhaust"} displayProp={"Start"} stringProp />
            <RadioLabelCol groupNameProp={"exhaustGroup"} valueProp={0} onChangeProp={"exhaust"} displayProp={"Stop"} stringProp />
         </RadioButtonRow>

         <RadioButtonRow promptRowSizeProp={3} valueRowSizeProp={4} titleProp={"Burner"} descriptionProp="">
            <RadioLabelCol groupNameProp={"burnGroup"} valueProp={"true"} onChangeProp={"burner"} displayProp={"On"} trueFalseProp />
            <RadioLabelCol groupNameProp={"burnGroup"} valueProp={"false"} onChangeProp={"burner"} displayProp={"Off"} trueFalseProp />
         </RadioButtonRow>

         <RadioButtonRow promptRowSizeProp={3} valueRowSizeProp={4} titleProp={"Timer"} descriptionProp="">
            <RadioLabelCol groupNameProp={"timerGroup"} valueProp={1} onChangeProp={"timer"} displayProp={"Start"} stringProp />
            <RadioLabelCol groupNameProp={"timerGroup"} valueProp={0} onChangeProp={"timer"} displayProp={"Stop"} stringProp />
         </RadioButtonRow>

         <RadioButtonRow promptRowSizeProp={3} valueRowSizeProp={4} titleProp={"Circulation Speed"} descriptionProp="">
            <RadioLabelCol groupNameProp={"speedGroup"} valueProp={0} onChangeProp={"circulationSpeed"} displayProp={"Low"} stringProp />
            <RadioLabelCol groupNameProp={"speedGroup"} valueProp={1} onChangeProp={"circulationSpeed"} displayProp={"Medium"} stringProp />
            <RadioLabelCol groupNameProp={"speedGroup"} valueProp={2} onChangeProp={"circulationSpeed"} displayProp={"High"} stringProp />
         </RadioButtonRow>

         <InputRangeRow
            titleProp={"Yield Pounds"}
            descriptionProp={""}
            sizeProp={3}
            colSizeProp={3}
            typeProp={"text"}
            minProp={2000}
            maxProp={2000}
            propertyNameProp={"pounds"}
            errorDialogueProp={"2,000 only"}
            floatProp={false}
         />

         <CommonRows />
      </>
   );
}
